<div class="dropdown-container">
  <button 
    type="button"
    class="dropdown-button" 
    (click)="toggleDropdown(); $event.stopPropagation()"
    [disabled]="disabled">
    <span>{{ getSelectedLabel() }}</span>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" 
         [class.rotated]="isOpen">
      <path d="M5.28 7.38L10 12.1L14.72 7.38" stroke="#15172E" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  
  <div
    class="dropdown-menu"
    [class.open-upward]="openUpward"
    [ngStyle]="menuStyle"
    *ngIf="isOpen"
    (click)="$event.stopPropagation()">
    <div class="dropdown-options">
      <div
        class="dropdown-option"
        *ngFor="let option of options; trackBy: trackByValue"
        [class.selected]="isSelected(option.value)"
        (click)="selectOption(option.value)">
        <span class="option-label">{{ option.label }}</span>
      </div>
      <div class="dropdown-option empty" *ngIf="!options?.length">
        <span class="option-label">No Options</span>
      </div>
    </div>
  </div>
</div>
